import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpHeaders, HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SmsDaoService {

  private BASE_URL = environment.apiURL;
  private OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json; charset=UTF-8'
    })
  };

  constructor( private http: HttpClient ) { }

  public getSmsList(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    return this.http.get(this.BASE_URL + 'private/v2.0/smsMaintenance/sms/all', options);
  }

  public getSmsCounter(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    return this.http.get(this.BASE_URL + 'private/v2.0/smsMaintenance/count', options);
  }

  public getSmsInfo(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/smsMaintenance/ws_getSmsDetails', item, options);
  }

  public addNewSms(context, lang, udid, smsName, centerInternalIds, active, smsSubject, smsPickAppointment, smsPickTurn, smsPreviousTurn, smsArrivalTurn) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { smsName, centerInternalIds, active, smsSubject, smsPickAppointment, smsPickTurn, smsPreviousTurn, smsArrivalTurn };
    return this.http.post(this.BASE_URL + 'private/v2.0/smsMaintenance/sms', item, options);
  }

  public updateSmsInfo(context, lang, udid, internalId, smsName, active, smsSubject) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, smsName, active, smsSubject };
    return this.http.patch(this.BASE_URL + 'private/v2.0/smsMaintenance/sms', item, options);
  }

  public updateSmsCenters(context, lang, udid, internalId, centerInternalIds) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, centerInternalIds };
    return this.http.patch(this.BASE_URL + 'private/v2.0/smsMaintenance/sms/center', item, options);
  }

  public updateSmsTemplates(context, lang, udid, internalId, active, smsPickAppointment, smsPickTurn, smsPreviousTurn, smsArrivalTurn) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, active, smsPickAppointment, smsPickTurn, smsPreviousTurn, smsArrivalTurn };
    return this.http.patch(this.BASE_URL + 'private/v2.0/smsMaintenance/sms', item, options);
  }

  public updateSmsStatus(context, lang, udid, internalId, active) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, active };
    return this.http.patch(this.BASE_URL + 'private/v2.0/smsMaintenance/sms', item, options);
  }

  public deleteSms(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/smsMaintenance/ws_deleteSms', item, options);
  }

}
